import { render, staticRenderFns } from "./ReadQuantity.vue?vue&type=template&id=6a899a88&scoped=true"
import script from "./ReadQuantity.vue?vue&type=script&lang=js"
export * from "./ReadQuantity.vue?vue&type=script&lang=js"
import style0 from "./ReadQuantity.vue?vue&type=style&index=0&id=6a899a88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a899a88",
  null
  
)

export default component.exports